'use client'

import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { debounce } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { fetchAdmins, fetchPatienten } from '../apiCalls/usersApi'
import { getAdmins } from '../Localstorage/localstorage'

const people = [
  {
    id: 1,
    full_name: 'Leslie Alexander',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  {
    id: 1,
    full_name: 'Peter',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  {
    id: 1,
    full_name: 'Tom',
    imageUrl:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  },
  // More users...
]

const  SelectAdmins = ({selected, setSelected , label = true}) =>  {
  const [query, setQuery] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('');
  const admins = getAdmins();
  const [data, setData] = useState(admins);


  // Add debounced search function
  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      fetchAdmins(50, 0, searchQuery, setLoading, setError, setData);
    }, 300),
    []
  );


  return (
    <Combobox
      as="div"
      value={selected || data[0]}
      onChange={(person) => {
        setQuery('')
        setSelected(person)
      }}
    >
      {label && <Label className="dark:text-white block text-sm/6 font-medium text-gray-900 mb-2">Zoek op specialist</Label>}
      <div className="relative">
        <ComboboxInput
          className="block w-full rounded-md border border-wa-border bg-wa-panel2 py-1.5 pl-3 pr-12 text-base text-wa-text outline-none placeholder:text-wa-muted focus:border-wa-accent focus:ring-2 focus:ring-wa-accent/40 sm:text-sm/6"
          onChange={(event) => {
            setQuery(event.target.value);
            debouncedSearch(event.target.value);
          }}
          onBlur={() => setQuery('')}
          displayValue={(person) => person?.full_name}
        />
        <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 text-wa-muted focus:outline-none">
          <ChevronUpDownIcon className="size-5" aria-hidden="true" />
        </ComboboxButton>

        {data.length > 0 && (
          <ComboboxOptions className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md border border-wa-border bg-wa-panel2 py-1 text-base shadow-lg focus:outline-none sm:text-sm">
            {data.map((person) => (
              <ComboboxOption
                key={person.id}
                value={person}
                className="group relative cursor-default select-none py-2 pl-3 pr-9 text-wa-text data-[focus]:bg-wa-hover data-[focus]:text-wa-text data-[focus]:outline-none"
              >
                <div className="flex items-center">
                  <img src={person?.avatar} alt="" className="size-6 shrink-0 rounded-full" />
                  <span className="ml-3 truncate group-data-[selected]:font-semibold">{person?.full_name}</span>
                </div>

                <span className="absolute inset-y-0 right-0 hidden items-center pr-4 text-wa-accent group-data-[selected]:flex group-data-[focus]:text-wa-text">
                  <CheckIcon className="size-5" aria-hidden="true" />
                </span>
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        )}
      </div>
    </Combobox>
  )
}

export default SelectAdmins;